export enum ReviewResultEnum {
  Right = 'right',
  Wrong = 'wrong',
  HalfRight = 'half_right',
}
